import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { GSSelect } from "golfstatus_react_components";

export const getBankAccountForm = ( context, bankAccount ) => {
    const accountTypes = [
        { label: 'Checking', value: 'checking' },
        { label: 'Savings', value: 'savings' },
    ];
    const accountType = accountTypes.find(
        (type) => type.value === bankAccount.accountType
    );

    const validAccountNumber = (value) => {
        return value === bankAccount?.accountNumber;
    };
    const validRoutingNumber = (value) => {
        return value?.length === 9;
    };

    return [
        {
            type: 'vertical xx-large-gap',
            fields: [
                {
                    label: 'Account Type',
                    isEditable: true,
                    customView: true,
                    failedValidation: context.validationFailed,
                    validation: {
                        isValid: () => bankAccount.accountType !== '',
                        invalidLabel: 'Account type is required',
                    },
                    value: (
                        <GSSelect
                            options={accountTypes}
                            selectedOption={accountType}
                            placeholder='Select an Account Type…'
                            onChange={(inputValue) => {
                                context.updateBankAccount(inputValue?.value, 'accountType')
                            }}
                        ></GSSelect>
                    ),
                    required: true,
                },
                {
                    label: 'Routing Number',
                    failedValidation: context.validationFailed,
                    description: 'Routing numbers must be 9 digits.',
                    validation: {
                        isValid: validRoutingNumber,
                        invalidLabel: 'Routing number must be 9 digits',
                    },
                    value: bankAccount.routingNumber,
                    isEditable: true,
                    placeholder: 'e.g. 123456789',
                    required: true,
                    onChange: (e) => context.updateBankAccount(e.target.value, 'routingNumber'),
                },
                {
                    label: 'Account Number',
                    failedValidation: context.validationFailed,
                    value: bankAccount.accountNumber,
                    isEditable: true,
                    description: 'Account numbers must be 17 digits or less.',
                    placeholder: 'e.g. 1234567890',
                    required: true,
                    onChange: (e) => context.updateBankAccount(e.target.value, 'accountNumber'),
                },
                {
                    label: 'Confirm Account Number',
                    failedValidation: context.validationFailed,
                    validation: {
                        isValid: validAccountNumber,
                        invalidLabel: 'Account numbers do not match',
                    },
                    value: context.confirmedAccountNumber,
                    isEditable: true,
                    placeholder: 'e.g. 1234567890',
                    required: true,
                    onChange: (e) => {
                        context.setIsValid(true);
                        context.setConfirmedAccountNumber(e.target.value);
                    },
                },
            ],
        },
    ];
};

export const getBankAccountVerificationForm = (context) => {
    if (context) {
        return [
            {
                type: 'vertical xx-large-gap',
                fields: [
                    {
                        label: 'Deposit #1',
                        failedValidation: context.validationFailed,
                        validation: {
                            isValid: () => context.amounts.verifyAmountOne && context.amounts.verifyAmountOne >= 0.01,
                            invalidLabel: "Invalid amount",
                        },
                        leftIcon: faDollarSign,
                        type: "number",
                        value: context.amounts.verifyAmountOne,
                        isEditable: true,
                        placeholder: '0.00',
                        required: true,
                        onChange: (e) => context.updateAmounts(e.target.value, 'verifyAmountOne'),
                    },
                    {
                        label: 'Deposit #2',
                        failedValidation: context.validationFailed,
                        validation: {
                            isValid: () => context.amounts.verifyAmountTwo && context.amounts.verifyAmountTwo >= 0.01,
                            invalidLabel: "Invalid amount",
                        },
                        leftIcon: faDollarSign,
                        type: "number",
                        value: context.amounts.verifyAmountTwo,
                        isEditable: true,
                        placeholder: '0.00',
                        required: true,
                        onChange: (e) => context.updateAmounts(e.target.value, 'verifyAmountTwo'),
                    },
                ]
            }
        ];
    }
};
